import router from './router';
import store from '../store/store';
import MicrofrontendLoader from '../helpers/microfrontend-loader';
import axios from './axios';
import config from './config';

// Login redirect
router.beforeEach(async (to, _from, next) => {
  let isUserAuthorised;
  try {
    isUserAuthorised = Boolean((await axios.get(`${config.microservices.client}/isauthorised`)).data.success);
  } catch (e) { isUserAuthorised = false; }
  if (!isUserAuthorised && !to.meta.anon) {
    next(`/Login?ReturnUrl=${encodeURIComponent(to.fullPath)}`);
  } else {
    next();
  }
});

// Select client guard
router.beforeEach(async (to, _from, next) => {
  if (!store.getters.isImpersonator && to.path.startsWith('/SelectClient')) {
    next('/Login');
  } else {
    next();
  }
});

// Select client redirect
router.beforeEach(async (to, _from, next) => {
  const unselectedImpersonator = store.getters.isImpersonator && !store.getters.isClient;
  const invalidPath = !to.meta.anon && !to.path.startsWith('/SelectClient');

  if (unselectedImpersonator && invalidPath) {
    next(`/SelectClient?ReturnUrl=${encodeURIComponent(to.fullPath)}`);
  } else {
    next();
  }
});

// Redirect to homepage if user has no sufficient rights to open user management page
router.beforeEach(async (to, _from, next) => {
  const hasUserManagementClaim = store.getters.userPermissions.includes('user-management');
  const userManagementPath = to.path.startsWith('/Users');

  if (!hasUserManagementClaim && userManagementPath) {
    next('/Dashboard');
  } else {
    next();
  }
});

// Sync Vue2 and Vue3 routers but prevent double navigation
router.afterEach((to, from) => {
  if (window.reportingV2 && window.reportingV2.router) {
    if (from.fullPath.startsWith('/ReportingV2/Home') && to.path.startsWith('/ReportingV2/Home')) return;
    if (from.fullPath.startsWith('/ReportingV2/Campaign') && to.path.startsWith('/ReportingV2/Campaign')) return;
    if (from.fullPath.startsWith('/ReportingV2/Overall-Performance')
      && to.path.startsWith('/ReportingV2/Overall-Performance')) return;
    if (to.fullPath === window.reportingV2.router.currentRoute.value.fullPath) return;
    window.reportingV2.router.push(to.fullPath);
  }
});

// Manage Vue3 component visibility
router.afterEach(async (to) => {
  const mainContent = document.getElementById('main-content');
  const embedDiv = document.getElementById('lf-suite-webeo-portal-reporting-v2');
  if (to.path.startsWith('/ReportingV2')) {
    if (mainContent && mainContent.style) {
      mainContent.style.display = 'none';
    }
    if (embedDiv && embedDiv.style) {
      embedDiv.style.display = 'block';
    }
  } else {
    if (mainContent && mainContent.style) {
      mainContent.style.display = 'flex';
    }
    if (embedDiv && embedDiv.style) {
      embedDiv.style.display = 'none';
    }
  }
});

// Microfrontend loader
router.beforeEach(async (to, _from, next) => {
  if (!to.path.startsWith('/ReportingV2')) {
    try {
      const nextPath = await MicrofrontendLoader.load(to);
      next(nextPath);
    } catch (e) {
      store.dispatch('notify', { title: 'Error', message: 'There was a problem loading  Reporting V2 page' });
      console.log(`Exception while doing something: ${e}`);
    }
  } else {
    next();
  }
});

// Experience redirect for CamapignFlow feature
router.beforeEach(async (to, _from, next) => {
  if (to.path.startsWith('/Experiences')) {
    const campaignFlow = Boolean(store.getters.hasClientFeature('CampaignFlow'));
    if (campaignFlow) {
      next('/Campaigns');
    }
  }
  next();
});

// Require feature
router.beforeEach(async (to, _from, next) => {
  if (!to.meta || !to.meta.feature) {
    next();
  } else {
    const valid = Boolean(store.getters.hasClientFeature(to.meta.feature));
    next(valid);
  }
});

// Document title setter
router.beforeEach(async (to, _from, next) => {
  const title = to.meta && to.meta.title;
  document.title = title ? `Webeo - ${to.meta.title}` : 'Webeo';
  next();
});

// First time tutorial
router.beforeEach(async (to, _from, next) => {
  if (to.path.startsWith('/Dashboard')
    && store.getters.userInfo.showTutorial
    && Boolean(store.getters.hasClientFeature('CampaignFlow'))
    && Boolean(store.getters.hasClientFeature('CampaignsUI'))) {
    store.dispatch('updateShowUserTutorial', true);
  }

  next();
});
